import axios from "axios";
import {baseUrl} from "./config";

export const logPageView = tracking => axios.post(`${baseUrl}/logPageView`, {
  ...tracking
})

export const getOptions = (type, term) => axios.get(`${baseUrl}/getOptions`, {
  params: {
    type,
    term
  }
})
export const getKBStats = () => axios.get(`${baseUrl}/getKBStats`)
export const getDrugNames = () => axios.get(`${baseUrl}/drugs`)
export const getAlternateMedicineNames = () => axios.get(`${baseUrl}/alternateMedicine`)
export const getDiseaseNames = () => axios.get(`${baseUrl}/diseases`)
export const getGeneNames = () => axios.get(`${baseUrl}/genes`)
export const getPDBNames = () => axios.get(`${baseUrl}/pdbs`)
export const getMiRNANames = () => axios.get(`${baseUrl}/miRNAs`)
export const getLncRNANames = () => axios.get(`${baseUrl}/lncRNAs`)
export const getAllDrugDiseasePairs = () => axios.get(`${baseUrl}/drug-disease`)
export const getAllDrugPDBPairs = () => axios.get(`${baseUrl}/drug-pdb`)
export const getAllDiseaseGenePairs = () => axios.get(`${baseUrl}/disease-gene`)
export const getAllDiseaseMiRNAPairs = () => axios.get(`${baseUrl}/disease-miRNA`)
export const getAllDiseaseLncRNAPairs = () => axios.get(`${baseUrl}/disease-lncRNA`)

export const getDrugDetails = data => axios.post(`${baseUrl}/drugSearch`, data)
export const getAlternateMedicineSearch = data => axios.post(`${baseUrl}/alternateMedicineSearch`, data)
export const getDiseaseSearch = data => axios.post(`${baseUrl}/diseaseSearch`, data)

export const getDiseaseStats = data => axios.post(`${baseUrl}/getDiseaseStats`, data)
export const getGeneDetails = data => axios.post(`${baseUrl}/geneSearch`, data)
export const getMiRNASearch = data => axios.post(`${baseUrl}/miRNASearch`, data)
export const getLncRNASearch = data => axios.post(`${baseUrl}/lncRNASearch`, data)
export const getPDBSearch = data => axios.post(`${baseUrl}/pdbSearch`, data)
export const getDrugDiseaseSearch = data => axios.post(`${baseUrl}/drugDiseaseSearch`, data)
export const getDrugPDBSearch = data => axios.post(`${baseUrl}/drugPDBSearch`, data)
export const getDiseaseGeneSearch = data => axios.post(`${baseUrl}/diseaseGeneSearch`, data)
export const getDiseaseMiRNASearch = data => axios.post(`${baseUrl}/diseaseMiRNASearch`, data)
export const getDiseaseLncRNASearch = data => axios.post(`${baseUrl}/diseaseLncRNASearch`, data)

export const getTopDrugSearch = () => axios.get(`${baseUrl}/getTopDrugSearch`)
export const getTopAlternateMedicineSearch = () => axios.get(`${baseUrl}/getTopAlternateMedicineSearch`)
export const getTopDiseaseSearch = () => axios.get(`${baseUrl}/getTopDiseaseSearch`)
export const getTopGeneSearch = () => axios.get(`${baseUrl}/getTopGeneSearch`)
export const getTopPDBSearch = () => axios.get(`${baseUrl}/getTopPDBSearch`)
export const getTopMiRNASearch = () => axios.get(`${baseUrl}/getTopMiRNASearch`)
export const getTopLncRNASearch = () => axios.get(`${baseUrl}/getTopLncRNASearch`)
export const getTopDrugDiseaseSearch = () => axios.get(`${baseUrl}/getTopDrugDiseaseSearch`)
export const getTopDrugPDBSearch = () => axios.get(`${baseUrl}/getTopDrugPDBSearch`)
export const getTopDiseaseGeneSearch = () => axios.get(`${baseUrl}/getTopDiseaseGeneSearch`)
export const getTopDiseaseMiRNASearch = () => axios.get(`${baseUrl}/getTopDiseaseMiRNASearch`)
export const getTopDiseaseLncRNASearch = () => axios.get(`${baseUrl}/getTopDiseaseLncRNASearch`)